import React from 'react';
// import PointLoginLogo from './../../resources/point_club_logo.jpg'
export const PullDown = (props) => {

    const option = props.data.map((value,index) =>
            <option key={index} value={value.value}>
                {value.option}
            </option>
    );
    return(
        <select 
            style={props.selectStyle} 
            disabled={props.disabled} 
            defaultValue={props.selectedValue} 
            id={props.id} 
            className={props.class}
            onChange={props.onChange}>
            {option}
        </select>
    );
}